import { writable } from 'svelte/store';

export interface selectedAccountInitialState {
	account?: any;
	mode?: 'edit' | 'show';
	uploading: boolean;
	loaded: boolean;
	loading: boolean;
	error?: Error;
}

const initialValue = {
	account: undefined,
	mode: undefined,
	uploading: false,
	loaded: false,
	loading: false,
	error: undefined
};

const selectedAccount = Object.freeze(writable<selectedAccountInitialState>(initialValue));
export default selectedAccount;
